module.exports = "/assets/data/ca7b5393da7a3130c9332ad4d8904cdc-EC2N.data.json";